import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../../core/auth.service'; // ✅ fixed import path
import { baseUrl } from '../../../constants';

export interface Activity {
  id?: string;
  trackingId: string;
  customerName: string;
  receiverName: string;
  status: string;
  assignedRider?: string;
  paid?: boolean;
  createdAt?: string;
}

@Injectable({ providedIn: 'root' })
export class ActivityService {
  private baseUrl = `${baseUrl}DeliveryActivity`; // ✅ corrected route

  constructor(private http: HttpClient, private auth: AuthService) {} // ✅ inject AuthService

  /**
   * ✅ Fetch all activities depending on user role and ID
   */
  getAll(): Observable<Activity[]> {
    const user = this.auth.getUser();
    const role = user?.role || '';
    const userId = user?.email || '';

    console.log('[ActivityService] Fetching activities for:', { role, userId });

    let params = new HttpParams();
    if (role) params = params.set('role', role);
    if (userId) params = params.set('userId', userId);

    return this.http.get<Activity[]>(`${this.baseUrl}/list`, { params });
  }

  /**
   * 🚴 Assign a rider to a delivery
   */
  assignRider(trackingId: string, riderId: string, riderName: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/assign/${trackingId}`, { riderId, riderName });
  }

  /**
   * 🔁 Update delivery status
   */
  updateStatus(trackingId: string, status: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/status/${trackingId}`, { status });
  }

  /**
   * 💰 Mark delivery as paid
   */
  markAsPaid(trackingId: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/paid/${trackingId}`, {});
  }
}
